import React, { Component } from 'react';
import { Col, Form, Row, Select, Tabs } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

import * as programmeController from '../../../../../../services/api/programme';
import './ProgrammeSearchPane.scss';

const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;

export default class ProgrammeSearchPane extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programmes: [],
            filteredProgrammes: [],
            selectedProgrammes: [],
        }
    }

    handleSearch(searchText) {
        const { programmes } = this.state;
        let newProgrammes = [];

        if (searchText)
            newProgrammes = _.filter(programmes, (record) => _.filter(_.map(_.values(record), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchText.toUpperCase()) !== -1).length !== 0);
        else
            newProgrammes = programmes;

        this.setState({ filteredProgrammes: newProgrammes });
    }

    handleChange(value) {
        this.setState({
            selectedProgrammes: value
        });
    }

    componentDidMount() {
        programmeController.getProgrammes()
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json, filteredProgrammes: json }))
    }

    render() {
        const { programmes, filteredProgrammes, selectedProgrammes } = this.state;
        const options = _.map(filteredProgrammes, (programme) => (
            <Option key={programme.id} label={`${programme.programme_code} - ${programme.name}`} value={programme.id}>
        		{`[${programme.course_code ? programme.course_code.name : 'N/A'}] ${programme.programme_code} - ${programme.name}`}
        	</Option>
        ));

        return (
            <div className="ProgrammeSearchPane">
				<Select
					mode="multiple"
        			labelInValue
        			optionLabelProp="label"
        			placeholder="Type to search programme information"
					value={selectedProgrammes}
			        filterOption={false}
			        onSearch={(searchText) => this.handleSearch(searchText)}
			        onChange={(value) => this.handleChange(value)}
			        style={{ width: '100%' }}
				>
					{options}
				</Select>
				<Tabs
					hideAdd
					type="card"
				>
					{
						selectedProgrammes.map((programme) => {
							const targetProgramme = _.find(programmes, { id: programme.key });
        					const { name, status, course_code, programme_category, center, institute, programme_code, tutor, programme_date, application_due_date, head_count, fee, prerequisite, remarks } = targetProgramme;
					        const formItemLayout = {
					            labelCol: {
					                xs: { span: 24 },
					                sm: { span: 8 },
					            },
					            wrapperCol: {
					                xs: { span: 24 },
					                sm: { span: 16 },
					            },
					        };
							return (
								<TabPane tab={programme.label} key={programme.key}>
					                <Form className="programme-form">
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Name">
					                            	<span>{name}</span>
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Status">
					                            	<span>{status}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Course Code">
					                            	<span>{course_code ? course_code.name : ''}</span>
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Programme Category">
					                            	<span>{programme_category ? programme_category.name : ''}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Center">
					                            	<span>{center ? center.name : ''}</span>
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Institute">
					                            	<span>{institute ? institute.name : ''}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Programme Code">
					                            	<span>{programme_code}</span>
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Tutor">
					                            	<span>{tutor}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Programme Date">
                            						<span>{programme_date ? moment(programme_date).format('YYYY-MM-DD') : '--'}</span>
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Application Due Date">
                            						<span>{application_due_date ? moment(application_due_date).format('YYYY-MM-DD') : '--'}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                    <Row gutter={32}>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Available Place(s)">
					                            	<span>0 / </span>{head_count}
					                            </FormItem>
					                        </Col>
					                        <Col span={12}>
					                            <FormItem {...formItemLayout} label="Fee">
                            						<span>{numeral(fee).format('$0,0')}</span>
					                            </FormItem>
					                        </Col>
					                    </Row>
					                	<Row gutter={32}>
					                		<Col span={12}>
						                        <FormItem {...formItemLayout} label="Pre-requisites">
						                        	<span>{prerequisite}</span>
						                        </FormItem>
					                		</Col>
					                		<Col span={12}>
						                        <FormItem {...formItemLayout} label="Remarks">
						                        	<span>{remarks}</span>
						                        </FormItem>
					                		</Col>
					                	</Row>
					                </Form>
								</TabPane>
							)
						})
					}
				</Tabs>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadManagementPage/components/ProgrammeSearchPane/ProgrammeSearchPane.js